export default __webpack_public_path__ + "static/media/01-afl-logo-pts-russ.62c23d61.png";